import cn from 'classnames';
import { Avatar, ChannelPreviewUIComponentProps } from 'stream-chat-react';
import { useChannelPreviewState } from '@features/components/Chat/components/ChatContent/CustomPreviewMessenger/useChannelPreviewState';
import { type MessageForPreview } from './types';
import { PreviewTitle } from './PreviewMessageTitle/PreviewTitle';
import { PreviewMessageBody } from './PreviewMessageBody';

type CustomPreviewMessengerProps = ChannelPreviewUIComponentProps & {
  message?: MessageForPreview | null;
  searchQuery?: string;
};

export const CustomPreviewMessenger = ({
  active,
  channel,
  className,
  displayImage,
  displayTitle,
  latestMessagePreview,
  message,
  messageDeliveryStatus,
  onSelect,
  searchQuery,
}: CustomPreviewMessengerProps) => {
  const { getUnread, getMentionCount, isMuted } = useChannelPreviewState(channel);
  const unread = getUnread();
  const mentionCount = getMentionCount();

  return (
    <div className="str-chat__channel-preview-container">
      <button
        aria-label={`Select Channel: ${displayTitle}`}
        aria-selected={active}
        className={cn(
          'str-chat__channel-preview-messenger',
          'str-chat__channel-preview',
          {
            'str-chat__channel-preview-messenger--active': active,
            'str-chat__channel-preview-messenger--unread': !!unread,
          },
          className,
        )}
        data-testid="channel-preview-button"
        onClick={onSelect}
        role="option"
      >
        <div className="str-chat__channel-preview-messenger--left">
          <Avatar image={displayImage} name={displayTitle} />
        </div>
        <div className="str-chat__channel-preview-end">
          <div className="str-chat__channel-preview-end-first-row">
            <div className="str-chat__channel-preview-messenger--name">
              <PreviewTitle
                channel={channel}
                displayTitle={displayTitle}
                message={message}
                messageDeliveryStatus={messageDeliveryStatus}
              />
            </div>
          </div>
          <div className="str-chat__channel-preview-messenger--last-message">
            <PreviewMessageBody
              hasUnreadMentions={mentionCount > 0}
              latestMessagePreview={latestMessagePreview}
              message={message}
              unread={unread}
              isMuted={isMuted}
              searchQuery={searchQuery}
            />
          </div>
        </div>
      </button>
    </div>
  );
};
